import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegelDetailsService, IRegelDetails, RegelDetails, LeverancierDetails } from '../regel-details.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AutocompleteService, IFust, ISelectItem, IVbnFeatureValue } from '../autocomplete.service';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { debounceTime, tap, map, switchMap, startWith, finalize } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { FromVbnS02Pipe } from '../from-vbn-s02.pipe';
import { LeverancierStatus } from '../regels.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ContainsStringPipe } from '../containsstring.pipe';
import { IsNullOrEmptyPipe } from '../isnullorempty.pipe';

@Component({
    selector: 'app-regel-details',
    templateUrl: './regel-details.component.html',
    styleUrls: ['./regel-details.component.css']
})
export class RegelDetailsComponent implements OnInit {
    id: string;
    details: IRegelDetails = new RegelDetails();
    isLoadingDetails: boolean = false;
    isDisabled: boolean = false;
    isButtonDisabled: boolean = false;
    showBeladingValidationMessage: boolean = false;
    isAlternativeItem = false;

    public LeverancierStatus = LeverancierStatus;

    //fusten
    fusten: IFust[] = [];
    selectedFust1: IFust;
    selectedFust2: IFust;
    selectedFust3: IFust;
    isLoadingFusten = false;

    //hoogte
    control: FormControl = new FormControl('');
    controlSupplierAssignedId: FormControl = new FormControl('');
    omschrijvingControl: FormControl = new FormControl('', [Validators.required]);
    werkelijkePrijsControl: FormControl = new FormControl('', [Validators.required]);
    heights: IHeight[] = [];
    filteredHeights: Observable<IHeight[]>;
    filteredAssignedIds: Observable<ISelectItem[]>;
    selectedHeight?: number;
    isLoadingSupplierAssignedIds: boolean;
    dooshoogtes: number[] = [];

    constructor(
        public dialogRef: MatDialogRef<RegelDetailsComponent>,
        private alternativeDialogRef: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private _autocompleteService: AutocompleteService,
        private _detailsService: RegelDetailsService,
        private _snackBar: MatSnackBar) { }

    ngOnInit() {

        this.isLoadingDetails = true;

        this._autocompleteService.getDooshoogtes('').subscribe((data: number[]) => this.dooshoogtes = data);

        this._autocompleteService.getFusten('', true)
            .subscribe((fusten: IFust[]) => {
                this.fusten = fusten;
            });

        this._detailsService.get(this.data.id)
            .subscribe(data => {
                if (!data.leverancierDetails.supplierAssignedId)
                    data.leverancierDetails.supplierAssignedId = data.supplierAssignedId;
                this.setAanvraagRegelDetails(data);
            });
    }

    private setAanvraagRegelDetails(data: IRegelDetails) {

        this.isLoadingDetails = false;
        this.details = data;
        this.isDisabled = data.leverancierDetails.confirmationDate != null;

        if (this.details.leverancierDetails.fustNr1) {
            var fust = this.fusten.find(f => f.id == this.details.leverancierDetails.fustNr1);
            if (fust) {
                this.selectedFust1 = fust;
            }
            else {
                this._autocompleteService.getFust(this.details.leverancierDetails.fustNr1)
                    .subscribe(data => {
                        if (data) {
                            this.selectedFust1 = data;
                        }
                    });
            }
        }
        if (this.details.leverancierDetails.fustNr2) {
            var fust = this.fusten.find(f => f.id == this.details.leverancierDetails.fustNr2);
            if (fust) {
                this.selectedFust2 = fust;
            }
            else {
                this._autocompleteService.getFust(this.details.leverancierDetails.fustNr2)
                    .subscribe(data => {
                        if (data) {
                            this.selectedFust2 = data;
                        }
                    });
            }
        }
        if (this.details.leverancierDetails.fustNr3) {
            var fust = this.fusten.find(f => f.id == this.details.leverancierDetails.fustNr3);
            if (fust) {
                this.selectedFust3 = fust;
            }
            else {
                this._autocompleteService.getFust(this.details.leverancierDetails.fustNr3)
                    .subscribe(data => {
                        if (data) {
                            this.selectedFust3 = data;
                        }
                    });
            }
        }

        // set height of regel
        this.filteredHeights = this.control.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
        );

        this.filteredAssignedIds = this.controlSupplierAssignedId.valueChanges.pipe(
            startWith(''),
            debounceTime(300),
            tap(() => this.isLoadingSupplierAssignedIds = true),
            switchMap((value: string) => this._autocompleteService.getSupplierAssignedIDs(value, this.details.kwekerEan)
                .pipe(
                    map(val => val && val.data),
                    finalize(() => this.isLoadingSupplierAssignedIds = false),
                )),
            tap((val) => console.log(val)),
        );

        this.omschrijvingControl.patchValue(this.details.leverancierDetails.omschrijving);
        this.omschrijvingControl.valueChanges.subscribe(value => this.details.leverancierDetails.omschrijving = value);

        this.werkelijkePrijsControl.patchValue(this.details.leverancierDetails.werkelijkeInkoopprijs);
        this.werkelijkePrijsControl.valueChanges.subscribe(value => this.details.leverancierDetails.werkelijkeInkoopprijs = value);
        
        var fromVbnS02Pipe = new FromVbnS02Pipe();
        this._autocompleteService.getVbnFeatureValues('S02').subscribe(data => {
            let heights: any = [];
            data.forEach(function (item) {
                let height: IHeight = new Height();

                height.id = item.id;
                height.featureType = item.featureTypeId;
                height.featureValue = item.featureValue;
                height.decimalValue = fromVbnS02Pipe.transform(item.featureValue);
                height.description = item.description;

                heights.push(height);
            });
            this.heights = heights;
            let leverancierHeight = this.details.leverancierDetails.hoogte;
            var selectedHeight = this.heights.find(function (element) {
                return element.decimalValue == leverancierHeight;
            });
            if (selectedHeight) {
                this.selectedHeight = selectedHeight.decimalValue;
                this.control.patchValue(selectedHeight.description);
            }
            else {
                this.control.patchValue('');
            }

            this.control.validator = Validators.compose([
                Validators.required,
                FormCustomValidators.valueSelected(this.heights),
            ]);
        }, (err) => {
            this.isLoadingDetails = false;

            console.error("Failed! " + err);
            this._snackBar.open('Er is iets fout gegaan tijdens het ophalen van de details. Probeer opnieuw.', null, {
                duration: 2000,
                panelClass: ['kp-status-message', 'kp-status-message-error']
            });
        });

        this.evaluateButtonDisability();
    }

    private _filter(value: string): IHeight[] {
        if (!value) value = '';
        if (value === '') return this.heights;
        const filterValue = this._normalizeValue(value);
        return this.heights.filter(x => this._normalizeValue(x.description).includes(filterValue) || x.featureValue == filterValue);
    }

    onChangeFustNr() {
        if (this.details.leverancierDetails.fustNr1) {
            let fust = this.fusten.filter(x => x.id == this.details.leverancierDetails.fustNr1);
            if (fust.length) {
                this.selectedFust1 = fust[0];
            }
        }

        if (this.details.leverancierDetails.fustNr2) {
            let fust = this.fusten.filter(x => x.id == this.details.leverancierDetails.fustNr2);
            if (fust.length) {
                this.selectedFust2 = fust[0];
            }
        }

        if (this.details.leverancierDetails.fustNr3) {
            let fust = this.fusten.filter(x => x.id == this.details.leverancierDetails.fustNr3);
            if (fust.length) {
                this.selectedFust3 = fust[0];
            }
        }
    }

    private _normalizeValue(value: string): string {
        if (!value) value = '';
        if (typeof value === 'string') {
            return value.toLowerCase().replace(/\s/g, '');
        }

        return value;
    }

    displayFn(fust: IFust) {
        if (fust) {
            var name = `${fust.id}. ${fust.naam}`;
            if (fust.alfa) {
                name += ` (${fust.alfa})`;
            }
            return name;
        }
    }

    supplierAssignedIdSelected(event: MatAutocompleteSelectedEvent) {
        if (event.option && event.option.value) {
            this._detailsService.getSupply(event.option.value, this.details.kwekerEan).subscribe(supply => {
                // naam, vbn-code, potmaat, planthoogte, belading 
                this.details.leverancierDetails.omschrijving = supply.description;
                this.details.leverancierDetails.potmaat = supply.potmaat;
                this.details.photos = supply.images;

                this.details.leverancierDetails.hoogte = supply.hoogte;
                this.details.leverancierDetails.fustNr1 = supply.boxType;

                if (this.details.leverancierDetails.hoogte) this.control.setValue(this.details.leverancierDetails.hoogte + " cm");

                if (supply.boxType) {
                    this._autocompleteService.getFust(supply.boxType).subscribe((fust) => {
                        this.details.leverancierDetails.fustNr1 = fust.id;
                    });
                }

                this.details.leverancierDetails.aantalLagenPerLadingdrager1 = supply.numberOfLayersPerCarrier;
                this.details.leverancierDetails.fustenPerLaag1 = supply.numberOfBoxesPerLayer;
                this.details.leverancierDetails.stuks1 = supply.numberOfUnitsPerBox;
            });
        }
    }


    openNewAanvraagRegel(id: string) {
        console.log('openNewAanvraagRegel ' + id);
        this.isAlternativeItem = true;

        var alternativeItem = {
            ...this.details,
            photos: [],
            leverancierDetails: {
                kwekerEan: this.details.kwekerEan,
                parentId: id,
                //alternatieveOfferteAanvraagRegelId: this.details.sourceId,
                offerteAanvraagId: this.details.offerteAanvraagId,
                geldigheidKwekersaanbiedingTot: this.details.leverancierDetails.geldigheidKwekersaanbiedingTot,
                potmaat: this.details.potmaat,
                aantal: this.details.aantal,
                aantallenInAanvraagType: this.details.aantallenInAanvraagType
            },
        };

        this.setAanvraagRegelDetails(alternativeItem);
    }

    onEnter(evt: any) {
        const selectedHeight = this.heights.find(height =>
            height.decimalValue == evt.source.value);
        if (evt.source.selected) {
            if (selectedHeight) {
                this.details.leverancierDetails.hoogte = selectedHeight.decimalValue;
                this.control.patchValue(selectedHeight.description);
            }
        }
    }

    onChangeDooshoogte(event: any) {
        var newDooshoogte = event.source.value;
        if (newDooshoogte && newDooshoogte != 0) {
            // calculate number of dozen per layer
            var numberOfLayers = this.details.maxHoogteLadingdrager1 / newDooshoogte;
            if (numberOfLayers) {
                this.details.leverancierDetails.aantalLagenPerLadingdrager1 = Math.floor(numberOfLayers);
            }
        }
    }

    onChangeGeldigheidKwekersaanbieding(event: any) {
        let date = event.target.value;
        let dateElements = date.split('-');
        if (dateElements == null || dateElements == undefined || dateElements.length != 3 || dateElements[0].length == 4) {
            return;
        }

        let formattedDate: Date = null;
        if (dateElements[2].length == 4) {
            // dd-MM-yyyy
            formattedDate = new Date(dateElements[2] + '-' + dateElements[1] + '-' + dateElements[0]);
        }

        if (formattedDate != null) {
            this.details.leverancierDetails.geldigheidKwekersaanbiedingTot = formattedDate;
        }
    }

    evaluateButtonDisability() {
        this.isButtonDisabled = false;

        const containsStringPipe = new ContainsStringPipe();
        let showDooshoogte = containsStringPipe.transform(this.details.ladingdragerType1, 'pallet') || containsStringPipe.transform(this.details.ladingdragerType2, 'pallet') || containsStringPipe.transform(this.details.ladingdragerType3, 'pallet');

        if (showDooshoogte) {
            this.isButtonDisabled ||= !showDooshoogte || !this.details.leverancierDetails.dooshoogte;
        }

        const isNullOrEmptyPipe = new IsNullOrEmptyPipe();

        if (!isNullOrEmptyPipe.transform(this.details.ladingdragerType1 as any)) {
            this.isButtonDisabled ||= this.details.leverancierDetails.fustNr1 == null;
            this.isButtonDisabled ||= this.details.leverancierDetails.aantalLagenPerLadingdrager1 == null;
            this.isButtonDisabled ||= this.details.leverancierDetails.fustenPerLaag1 == null;
            this.isButtonDisabled ||= this.details.leverancierDetails.stuks1 == null;
        }

        if (!isNullOrEmptyPipe.transform(this.details.ladingdragerType2 as any)) {
            this.isButtonDisabled ||= !this.details.leverancierDetails.fustNr2 == null;
            this.isButtonDisabled ||= !this.details.leverancierDetails.aantalLagenPerLadingdrager2 == null;
            this.isButtonDisabled ||= !this.details.leverancierDetails.fustenPerLaag2 == null;
            this.isButtonDisabled ||= !this.details.leverancierDetails.stuks2 == null;
        }

        if (!isNullOrEmptyPipe.transform(this.details.ladingdragerType3 as any)) {
            this.isButtonDisabled ||= !this.details.leverancierDetails.fustNr3 == null;
            this.isButtonDisabled ||= !this.details.leverancierDetails.aantalLagenPerLadingdrager3 == null;
            this.isButtonDisabled ||= !this.details.leverancierDetails.fustenPerLaag3 == null;
            this.isButtonDisabled ||= !this.details.leverancierDetails.stuks3 == null;
        }

        this.showBeladingValidationMessage = this.isButtonDisabled;

        this.isButtonDisabled ||= !this.werkelijkePrijsControl.valid;
    }

    saveRegelDetails(leverancierStatus: LeverancierStatus) {
        this.evaluateButtonDisability();

        if ((leverancierStatus == LeverancierStatus.NietLeverbaarUitverkocht && !this.isDisabled) || (!this.isButtonDisabled && !this.isDisabled && !this.control.invalid)) {
            this.details.leverancierDetails.status = LeverancierStatus.Voltooid;
            this._detailsService.updateMeta(this.details.leverancierDetails)
                .subscribe(data => {
                    this._snackBar.open("Data opgeslagen", null, { duration: 2000 });
                    this.dialogRef.close(
                        {
                            refreshAllRows: this.isAlternativeItem,
                            result: true,
                            status: leverancierStatus,
                            item: this.details
                        });
                }, (err) => {
                    console.error("Failed! " + err);
                    this._snackBar.open('Er is iets fout gegaan tijdens het opslaan van de details. Probeer opnieuw.', null, {
                        duration: 2000,
                        panelClass: ['kp-status-message', 'kp-status-message-error']
                    });
                });
        }
    }
}

export class FormCustomValidators {
    static valueSelected(myArray: any[]): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            let selectboxValue = c.value;
            let pickedOrNot = myArray.filter(
                (alias) => alias.description === selectboxValue || alias.featureValue == selectboxValue
            );

            if (pickedOrNot.length > 0) {
                // everything's fine. return no error. therefore it's null.
                return null;
            } else {
                //there's no matching selectboxvalue selected. so return match error.
                return { match: true };
            }
        };
    }
}

export class Height implements IHeight {
    id: number;
    featureType: string;
    featureValue: string;
    decimalValue?: number;
    description: string;
}

export interface IHeight {
    id: number;
    featureType: string;
    featureValue: string;
    decimalValue?: number;
    description: string;
}
